module.exports = __webpack_public_path__ + "static/media/om_eyebrowshape_rounded.76de3b0e.png";